import dayjs from 'dayjs';
import { formatDate } from './formatFns';

export const isTMSDistributorFn = (distributorNameAbbrev) => distributorNameAbbrev === 'TMS';

export const isUSNonPDRegionFn = (regionCode) =>
  [
    '110',
    '120',
    '130',
    '150',
    '160',
    '170',
    '190',
    '210',
    '220',
    '230',
    '310',
    '320',
    '330',
    '340',
    '390',
    '800',
  ].includes(regionCode);

export const isGSTOrSETRegionFn = (regionCode) => ['500', '600'].includes(regionCode);

export const isMexicanDistributorFn = (distributorCode) => distributorCode === '92092';

export const isTDPRDistributorFn = (distributorCode) => distributorCode === '92121';

export const isUSADistributorFn = (distributorCode) => distributorCode === '91041';

export const isUSAMexicoTDPRDistributorFn = (distributorCode) =>
  ['92092', '92121', '91041'].includes(distributorCode);

export const isMexicanOrTDPRNonUSADistributor = ({ distributorCode }) =>
  !isUSADistributorFn(distributorCode) &&
  (isMexicanDistributorFn(distributorCode) || isTDPRDistributorFn(distributorCode));

export const isPrivateDistrMexTdpr = (regionCode) =>
  ['500', '600', '820', '830'].includes(regionCode);

export const isValidInvoiceDateFn = (invoiceDate) => {
  const currentDate = formatDate(dayjs().utc(), 'DD/MM/YYYY');
  const formatedInvoiceDate = formatDate(dayjs(invoiceDate).utc(), 'DD/MM/YYYY');
  const isNotCurrentDate = currentDate !== formatedInvoiceDate;
  const isAfter2016 = dayjs(invoiceDate).isAfter(dayjs('31/12/2016', 'DD/MM/YYYY'));
  return isNotCurrentDate && isAfter2016;
};
